import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {storesTicketsTableReady,rowsTicketsPerPageState,paginationTicketsState,searchStoreTicketTextState,storesTicketIdForAction,previousFilterStartDate,previousFilterEndDate,previousFilterCity,previousFilterStatus,previousFilterKitchen,previousFilterStore,previousFilterPlatform} from '../redux/stores'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/storeTable.css'



import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'

import {StoreTicketStatus,StoresComboList} from './DropDowns/index'



import {Kitchens,Cities,Platforms} from '../../../common/DropDowns/index'







import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'

function filterUnwantedData(storesTicketsData) {
    let array = []
    if (storesTicketsData && storesTicketsData.data && storesTicketsData.data.list) {
        array = storesTicketsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.store_name =  lineData.store.name ? lineData.store.name : "NA"
            newLineData.urbanpiper_id =  lineData.store.urbanpiper_id ? lineData.store.urbanpiper_id : "NA"
            newLineData.kitchen_name =  lineData.store && lineData.store.kitchen && lineData.store.kitchen.name ? lineData.store.kitchen.name : "NA"
            newLineData.kitchen_contact_no =  lineData.store && lineData.store.kitchen && lineData.store.kitchen.contact_no ? lineData.store.kitchen.contact_no : "NA"

            newLineData.cluster_contact_no =  lineData.store && lineData.store.kitchen && lineData.store.kitchen.cluster && lineData.store.kitchen.cluster.cluster_manager && lineData.store.kitchen.cluster.cluster_manager.mobile ? lineData.store.kitchen.cluster.cluster_manager.mobile : "NA"

            newLineData.kitchen_manager_contact_no =  lineData.store && lineData.store.kitchen && lineData.store.kitchen.kitchen_manager && lineData.store.kitchen.kitchen_manager.mobile ? lineData.store.kitchen.kitchen_manager.mobile : "NA"

            newLineData.city_name =  lineData.store && lineData.store.kitchen && lineData.store.kitchen.city && lineData.store.kitchen.city.name ? lineData.store.kitchen.city.name : "NA"


            newLineData.resolver =lineData.resolver  &&  lineData.resolver.name  &&  lineData.resolver.code ? lineData.resolver.name+" - "+lineData.resolver.code : "NA"

            newLineData.kitchen_code =  lineData.store && lineData.store.kitchen && lineData.store.kitchen.code ? lineData.store.kitchen.code : "NA"

            

            newLineData.brand_name =  lineData.store && lineData.store.brand && lineData.store.brand.name ? lineData.store.brand.name : "NA"


            newLineData.platform_name =lineData.platform_name ? lineData.platform_name : "NA"
            newLineData.type =lineData.type ? lineData.type : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"
            newLineData.created =lineData.created ? Helpers.getDateTimeFormatForUTC(lineData.created) : ""
            newLineData.modified =lineData.modified ? Helpers.getDateTimeFormatForUTC(lineData.modified) : ""
            newLineData.remarks =lineData.remarks ? lineData.remarks : "NA"
            newLineData.hold_till =lineData.hold_till ? Helpers.getDateTimeFormatForUTC(lineData.hold_till) : ""

            newLineData.reason="NA"
            if(lineData.reason && lineData.reason.name){
                newLineData.reason=lineData.reason.name ? lineData.reason.name : "NA"
            }

            newArray[i] = newLineData
        }
    }
    return newArray
}


class StoresTicketsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            storesTicketsData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_status:"",
            filter_kitchen_id:"",
            filter_city_id:"",
            filter_platform:"",
            rowCount: 15,
            storeSelectedId:0,
            //startDate: moment().startOf('month'),
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Yesterday': [moment().subtract(1, 'day'), moment().subtract(1, 'day')]
            },
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
        this.CSVData = []        
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(storesTicketsTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.STORES_TICKETS_TABLE)) 
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


            let previousFilterStartDate=moment().format("YYYY-MM-DD")
            let previousFilterEndDate=moment().format("YYYY-MM-DD")
            let previousFilterStatus=""
            let previousFilterCity=""
            let previousFilterKitchen=""
            let previousFilterStore=0
            let previousFilterPlatform=""

         if (this.props.stores && this.props.stores.previousFilterStartDate && this.props.stores.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.stores.previousFilterStartDate
         }
         if (this.props.stores && this.props.stores.previousFilterEndDate && this.props.stores.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.stores.previousFilterEndDate
         }
         if (this.props.stores && this.props.stores.previousFilterStatus && this.props.stores.previousFilterStatus!==undefined) {
            previousFilterStatus=this.props.stores.previousFilterStatus
         }
         if (this.props.stores && this.props.stores.previousFilterCity && this.props.stores.previousFilterCity!==undefined) {
            previousFilterCity=this.props.stores.previousFilterCity
         }
         if (this.props.stores && this.props.stores.previousFilterKitchen && this.props.stores.previousFilterKitchen!==undefined) {
            previousFilterKitchen=this.props.stores.previousFilterKitchen
         }
         if (this.props.stores && this.props.stores.previousFilterStore && this.props.stores.previousFilterStore!==undefined) {
            previousFilterStore=this.props.stores.previousFilterStore
         }
         if (this.props.stores && this.props.stores.previousFilterPlatform && this.props.stores.previousFilterPlatform!==undefined) {
            previousFilterPlatform=this.props.stores.previousFilterPlatform
         }

         
         this.setState({
              filter_status:previousFilterStatus,
              filter_kitchen_id:previousFilterKitchen,
              filter_city_id:previousFilterCity,
              storeSelectedId:previousFilterStore,
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate,
              filter_platform:previousFilterPlatform
         },() => {
            this.getStoresTicketsData();
        });

        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
       this.setState({
            tableHeight: (window.innerHeight - 280) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getStoresTicketsData = () => {
        apiService.getStoresTicketsData(this.state.startDate,this.state.endDate,this.state.storeSelectedId,this.state.filter_status,this.state.filter_kitchen_id,this.state.filter_city_id,this.state.filter_platform)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.stores && this.props.stores.previousTicketsPaginationValue) {
                            pageNo = this.props.stores.previousTicketsPaginationValue
                        }
                        this.setState({
                            storesTicketsData: array,
                            page: pageNo,
                        })
                        this.createCSVData(array)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(storesTicketsTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(storesTicketsTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.stores && this.props.stores.previousTicketsRowsPerPageValue) {
            value = this.props.stores.previousTicketsRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsTicketsPerPageState(value))
        this.dropUpManager()
    }



     addBtnCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        

        let addBtn=""

        if(row.status==="NEW" || row.status==="HOLD"){

            if(Helpers.checkPrivileges("/dashboard/storestickets/edit",this.props.user)){
                addBtn =<button
                    className="action-button"
                    style={{marginBottom: "1px" }}
                    onClick={(e) => {
                        e.preventDefault()
                        this.editStoreTicket(row)
                    }}>
                    <i className="fa fa-clock-o" aria-hidden="true"></i> Edit
                </button>
            }
        }
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{addBtn} </div>
        </div>)
    }

editStoreTicket= (row) =>{

    if (row && row.id) {
            this.props.dispatch(storesTicketIdForAction(row.id))
            this.props.history.push("/dashboard/storestickets/edit")
        } else {
            this.dialog.show({
                title: "Store Identification number not found",
                body: 'Store id is not available, So not able edit store',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    
}


assignAgent= (row) =>{

    if (row && row.id) {
            this.props.dispatch(storesTicketIdForAction(row.id))
            this.props.history.push("/dashboard/storestickets/assignAgent")
        } else {
            this.dialog.show({
                title: "Store Identification number not found",
                body: 'Store id is not available, So not able edit store',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    
}


 getFilteredTicketsList = () => {
       
        this.props.dispatch(storesTicketsTableReady(false))
        this.resetSearchAndPagination()
        this.getStoresTicketsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchStoreTicketTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    // resetFilterValues = () => {
    //     this.resetPagination()
    //     this.setState({
    //         storeSelectedId: 0
    //     }, () => {
    //         //this.props.dispatch(cityFilterState(0))
    //         this.getProductsData()
    //         this.props.dispatch(storesTicketsTableReady(false))
    //         this.props.dispatch(searchStoreTicketTextState(""))

    //         this.searchBox.wrappedInstance.refs.searchInput.value = ""
    //         this.searchBox.props.search("")
    //     })
        
        
    // }


   storeTicketStatusChange = (data) => {
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStatus(""))
             this.setState({
                filter_status :"",            
            })
        }else{
            this.props.dispatch(previousFilterStatus(data.value))
            this.setState({
                filter_status :data.value,            
            })
        }
    }


   platformChange = (data) => {
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterPlatform(""))
             this.setState({
                filter_platform :"",            
            })
        }else{
            this.props.dispatch(previousFilterPlatform(data.value))
            this.setState({
                filter_platform :data.value,            
            })
        }
    }

    

    kitchenChange = (data) => {

       
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterKitchen(""))
             this.setState({
                filter_kitchen_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterKitchen(data.value))
             this.setState({
            filter_kitchen_id :data.value,
            
        })
        }
    }
    cityChange = (data) => {

        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
              this.setState({
                filter_city_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
            filter_city_id :data.value,
            
            })
        }
    }
    storeChange = (data) => {

        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStore(""))
             this.setState({
                storeSelectedId :0            
            })
        }else{
            this.props.dispatch(previousFilterStore(data.value))
            this.setState({
            storeSelectedId :data.value,
            
        })
        }
    }

    


    onApplyEvent = (event, picker) => {
        let startDate = moment(picker.startDate)
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
            if (startDate.isAfter(moment().add(1, 'days')) ||
                endDate.isAfter(moment().add(1, 'days'))) {
                this.dialog.show({
                    title: "Date Chosen is greater than current date",
                    body: 'Please choose any Dates within current date and then try again',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            } else {

                this.props.dispatch(previousFilterStartDate(api_start_date))
                this.props.dispatch(previousFilterEndDate(api_end_date))

                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                })
            }
        }
    }


     createCSVData(csvData) {
        let ticketList = []
        if (csvData) {
            ticketList = JSON.parse(JSON.stringify(csvData))
            ticketList = createXLSheetdata(ticketList)
        }
        this.CSVData = ticketList
    }



   

    createCustomToolBar = props => {

        let ticketDetailsFilename = "storeTickets_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

            let startDate = "", endDate = "", start = "", end = "", label = ""

            startDate = moment(this.state.startDate)
            endDate = moment(this.state.endDate)

            start = moment(startDate).format('DD-MM-YYYY')
            end = moment(endDate).format('DD-MM-YYYY')

            label = start + ' to ' + end;

            if (start === end) {
                label = start
            }

        let firstComponent = ''

        
            firstComponent = <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>

        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 header-div-margins">
                    {firstComponent}

                    {(() => {
                        if(Helpers.checkPrivileges("/root/filter",this.props.user)){
                            return (

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id} />   
                    </div>
                    </div>

                      )
                        }
                    })()}

                     {(() => {
                        if(this.state.filter_city_id && this.state.filter_city_id!=="" && this.state.filter_city_id!==undefined){
                            return(
                           <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                            <div className="form-group">
                                <Kitchens kitchenChange={this.kitchenChange} selectedCity={this.state.filter_city_id} selectedValue={this.state.filter_kitchen_id} />   
                            </div>
                            </div>
                            )
                        }
                    })()}

                    {(() => {
                        if(this.state.filter_kitchen_id && this.state.filter_kitchen_id!=="" && this.state.filter_kitchen_id!==undefined){
                            return(

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <StoresComboList storeChange={this.storeChange} selectedKitchen={this.state.filter_kitchen_id} selectedValue={this.state.storeSelectedId} />    
                    </div>
                    </div>
                    )
                        }
                    })()}

                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 header-search-icon header-div-margins">
                    
                    {/*
                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        
                        <button
                            className="btn btn-primary button-custom"
                            style={{ marginBottom: "1px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.history.push("/dashboard/storestickets/live")
                            }}>Live Tickets</button>
                    </div>
                    */}
                    
                    <div className="col-md-12 col-sm-12 col-xs-12 div-margins">
                     {props.components.searchPanel}

                     </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 header-div-margins">

                <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                                   <Platforms platformChange={this.platformChange} selectedValue={this.state.filter_platform} />    
                                </div>
                    </div>

                 <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                                   <StoreTicketStatus storeTicketStatusChange={this.storeTicketStatusChange} selectedValue={this.state.filter_status} />    
                                </div>
                    </div>
                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredTicketsList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={ticketDetailsFilename}>
                            Export
                        </CSVLink>
                    </div>

                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return (
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.storesTicketsData.length>=(this.props.stores.previousTicketsPaginationValue*this.props.stores.previousTicketsRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.stores.previousTicketsPaginationValue*this.props.stores.previousTicketsRowsPerPageValue)-this.props.stores.previousTicketsRowsPerPageValue+1} to {this.props.stores.previousTicketsPaginationValue*this.props.stores.previousTicketsRowsPerPageValue} of {this.state.storesTicketsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.stores.previousTicketsPaginationValue*this.props.stores.previousTicketsRowsPerPageValue)-this.props.stores.previousTicketsRowsPerPageValue+1} to {this.state.storesTicketsData.length} of {this.state.storesTicketsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div>
            )
    }

    getFilteredStoreList = () => {
       
        this.props.dispatch(storesTicketsTableReady(false))
        this.resetSearchAndPagination()
        this.getStoresTicketsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchStoreTicketTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }



    
    resetFilterValues = () => {
        this.props.dispatch(storesTicketsTableReady(false))
        this.setState({
            //startDate: moment().startOf('month'),
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            filter_status:"",
            filter_kitchen_id:"",
            filter_city_id:"",
            filter_platform:"",
            storeSelectedId:0
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchStoreTicketTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity(""))
            this.props.dispatch(previousFilterStatus(""))
            this.props.dispatch(previousFilterPlatform(""))
            this.props.dispatch(previousFilterKitchen(""))
            this.props.dispatch(previousFilterStore(""))
            this.props.dispatch(previousFilterStartDate(moment().format("YYYY-MM-DD")))
            this.props.dispatch(previousFilterEndDate(moment().format("YYYY-MM-DD")))

        this.getStoresTicketsData();
        });

       

        
    }


     
      onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationTicketsState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.stores && this.props.stores.previousTicketsPaginationValue
            && this.props.stores.previousTicketsPaginationValue !== 1) {
            this.props.dispatch(paginationTicketsState(1))
            this.setState({
                page: 1
            })
        }
    }


    editStore = (row) => {
        if (row && row.id) {
            this.props.dispatch(storesTicketIdForAction(row.id))
            this.props.history.push("/dashboard/store/addedit")
        } else {
            this.dialog.show({
                title: "Store Identification number not found",
                body: 'Store id is not available, So not able edit store',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }





    renderStatusFormat = (cell, row, enumObject, rowIndex,) => {
        
        let statusTemp=<p>{row.status}</p>

        if(row.status==="HOLD"){
            statusTemp=<p>{row.status}<br/>{row.hold_till}</p>
        }

        if(row.status==="CLOSED"){
            statusTemp=<p>{row.status}<br/>{row.modified}</p>
        }

        return (<div className={"row ticket_status_"+row.status+""}>
            <div className="col-md-12 col-sm-12 col-xs-12">{statusTemp}</div>
        </div>)
    }

    renderReasonRemarks = (cell, row, enumObject, rowIndex,) => {
        
        let reason=""
        
            reason=<p>{row.reason}<br/>({row.remarks})</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{reason}</div>
        </div>)
    }


     renderContactNo = (cell, row, enumObject, rowIndex,) => {
        
        let contact_no=""
        
            contact_no=<p>{row.kitchen_contact_no}<br/>[ Kitchen Mngr. : {row.kitchen_manager_contact_no} ]
        <br/>[ Cluster Mngr. : {row.cluster_contact_no} ]</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{contact_no}</div>
        </div>)
    }

     renderKitchenCity = (cell, row, enumObject, rowIndex,) => {

        let kitchen=<p>{row.kitchen_name} - {row.city_name} </p>

          return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{kitchen}</div>
        </div>)
     }






    






    

    render() {
        let sizeperPage = 15

        if (this.props.stores && this.props.stores.previousTicketsRowsPerPageValue) {
            sizeperPage = this.props.stores.previousTicketsRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
           sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (


            <div className="storesTickets-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>                

                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.storesTicketsData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    >


                    <TableHeaderColumn
                        dataField="id"
                        isKey={true}
                        expandable={false}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Ticket Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="urbanpiper_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       UP Id
                    </TableHeaderColumn>
                   
                    
                    <TableHeaderColumn
                         dataFormat={this.renderKitchenCity}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Kitchen
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="store_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Store
                    </TableHeaderColumn>



                    <TableHeaderColumn
                        dataFormat={this.renderContactNo}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Contact
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="platform_name"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Platform
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="type"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Type
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataFormat={this.renderStatusFormat}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        //dataField="reason"
                        dataFormat={this.renderReasonRemarks}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Reason
                    </TableHeaderColumn>

                     <TableHeaderColumn
                        dataField="resolver"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Resolved By
                    </TableHeaderColumn>
                    


                    <TableHeaderColumn
                        dataField="created"                      
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Created on
                    </TableHeaderColumn>


                     <TableHeaderColumn
                        expandable={false}
                        dataFormat={this.addBtnCreator}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>  

                
                </BootstrapTable>
            </div>


        )



    }

}



const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        stores: state.stores
    }
}

export default connect(mapStateToProps)(withRouter(StoresTicketsTable))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/StoresTicketsTable.js